import React from 'react';
import { createPortal } from 'react-dom';

type ArrowAlign = 'center' | 'left' | 'right';

interface LessonTooltipProps {
  style: React.CSSProperties;
  /** 箭頭（朝上的三角形）的水平對齊方式 */
  arrowAlign?: ArrowAlign;
  children: React.ReactNode;
}

const ARROW_CLASS: Record<ArrowAlign, string> = {
  center: 'left-1/2 -translate-x-1/2',
  left: 'left-3',
  right: 'right-3',
};

/**
 * Lesson Guide 共用的深色 tooltip 氣泡。
 * 透過 portal 掛載於 body，pointer-events-none。
 */
export function LessonTooltip({ style, arrowAlign = 'center', children }: LessonTooltipProps) {
  return createPortal(
    <div style={style} className="z-tooltip pointer-events-none">
      <div className="relative bg-sky-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg w-max max-w-[200px] text-center">
        <div className={`absolute bottom-full ${ARROW_CLASS[arrowAlign]} w-2 h-2 bg-sky-900 rotate-45 translate-y-1`} />
        {children}
      </div>
    </div>,
    document.body
  );
}
